import React, { Component } from 'react';
import { soundManager } from 'soundmanager2';
import ReactSlider from 'react-slider';

const MP3_STREAM = 'https://stream.customchannels.net/hteao_web_128.mp3';

class Controls extends Component {

  constructor(props){
    super(props);
    this.state = {
      playing: false,
      volume: 50
    };
  }

  componentWillMount(){
      var self = this;
      soundManager.setup({
        debugMode: false,
        onready: function(){
          self.stream = soundManager.createSound({
            autoLoad: true,
            volume: self.state.volume,
            stream: true,
            url: MP3_STREAM
          });
        }
      });
  }

  changeVolume(e){
    let volume = e[1];
    this.stream.setVolume(volume);
    this.setState({ volume: volume });
  }

  playPause(){
    if(!this.state.playing){
      this.stream.play();
      this.setState({ playing: true });
    }else{
      this.stream.stop();
      this.setState({ playing: false });
    }
  }

  render() {
    return (
      <div className="Controls">
        <a onClick={ this.playPause.bind(this) } id="play-pause"><i className={ !this.state.playing ? "fa fa-play fa-4x" : "fa fa-pause fa-4x" }></i></a>
        <ReactSlider className="volume-slider" defaultValue={ this.state.volume } onChange={ this.changeVolume.bind(this) } withBars>
          <div className="volume-down"><i className="fa fa-2x fa-volume-down"></i></div>
          <div className="toggle"></div>
          <div className="volume-up"><i className="fa fa-2x fa-volume-up"></i></div>
        </ReactSlider>
      </div>
    );
  }
}

export default Controls;



// WEBPACK FOOTER //
// ./src/Controls.js